var map = {
	"./SignatureTemplate": [
		4459,
		[
			840
		]
	],
	"./SignatureTemplate.vue": [
		4459,
		[
			840
		]
	],
	"./components/Avatar": [
		8459,
		[
			459
		]
	],
	"./components/Avatar.vue": [
		8459,
		[
			459
		]
	],
	"./components/BannerPlaceholder": [
		3202,
		[
			202
		]
	],
	"./components/BannerPlaceholder.vue": [
		3202,
		[
			202
		]
	],
	"./components/PromoteSignature": [
		5899,
		[
			899
		]
	],
	"./components/PromoteSignature.vue": [
		5899,
		[
			899
		]
	],
	"./emailTemplate": [
		7850,
		[
			850
		]
	],
	"./emailTemplate.js": [
		7850,
		[
			850
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(function() {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(function() { return __webpack_require__(id); });
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 3783;
module.exports = webpackAsyncContext;